export const colorOptions = ['#88ECFF', '#ffb9f6', '#5dfca4'];
